import React from "react";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/pro-solid-svg-icons";
import { DefaultIconStyle } from "./styles";

export function IconPlay(props: Partial<FontAwesomeIconProps>): React.ReactElement {
  return <FontAwesomeIcon style={DefaultIconStyle} {...props} icon={faPlay} />;
}
